import { render, staticRenderFns } from "./studentInfoCertificationRecord.vue?vue&type=template&id=3d6e42fa&scoped=true"
import script from "./studentInfoCertificationRecord.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord.vue?vue&type=style&index=0&id=3d6e42fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e42fa",
  null
  
)

export default component.exports